import { Component, Input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';


@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [
    CommonNgModule,
    SvgIconComponent,    
  ],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() Theme:any;
  @Input() Path:any = '';
  @Input() Loading_sk: any;
  constructor() { }

  ngOnInit() {
  }
}
